import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const PaymentMethodIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  return (
    <svg
      style={style}
      className={className}
      id="Capa_1"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m482 271.474h-91c-33.076 0-60 26.909-60 60s26.924 60 60 60h91c16.553 0 30-13.462 30-30v-60c0-16.538-13.447-30-30-30zm-91 75c-8.284 0-15-6.716-15-15 0-8.286 6.716-15 15-15s15 6.714 15 15c0 8.284-6.716 15-15 15z" />
        <path d="m7.061 140.125 134.647-48.651h-111.708c-16.569 0-30 13.431-30 30 0 7.172 2.862 13.489 7.061 18.651z" />
        <path d="m428.013 80.297-14.513-39.888c-1.348-3.735-4.16-6.782-7.764-8.467-3.604-1.699-7.705-1.875-11.455-.498l-39.893 14.522c.712 15.943 8.104 28.1 17.833 35.458 13.965 10.515 36.419 13.752 55.792-1.127z" />
        <path d="m325.507 56.483-261.936 94.991h390.341l-15.385-42.279c-28.442 17.053-61.267 13.583-84.382-3.834-14.427-10.912-25.315-27.994-28.638-48.878z" />
        <path d="m301 331.474c0-49.629 40.371-90 90-90h91v-45c0-8.286-6.716-15-15-15h-437c-10.975 0-21.138-3.179-30-8.348v263.348c0 24.853 20.147 45 45 45h422c8.284 0 15-6.716 15-15v-45h-91c-49.629 0-90-40.371-90-90zm-119.326 70.356c-.222.081-.452.044-.674.121v19.522c0 8.291-6.709 15-15 15s-15-6.709-15-15v-20.064c-9.5-3.422-18.622-9.617-26.484-18.974-5.332-6.343-4.512-15.806 1.846-21.138 6.328-5.332 15.791-4.512 21.123 1.831 7.881 9.375 16.523 13.154 23.936 10.518 5.713-2.095 9.58-7.793 9.58-14.18 0-8.921-7.764-12.993-15-12.993-24.404 0-45-21.533-45-47.007 0-17.695 11.104-33.838 28.301-41.118.549-.232 1.144-.214 1.699-.425v-16.45c0-8.291 6.709-15 15-15s15 6.709 15 15v14.967c9.117 2.388 17.917 7.041 25.43 14.33 5.947 5.757 6.094 15.264.352 21.211-5.771 5.947-15.264 6.123-21.211.322-10.898-10.547-20.889-7.925-24.58-6.328-6.064 2.578-9.99 7.866-9.99 13.491 0 8.745 7.295 17.007 15 17.007 25.664 0 45 18.486 45 42.993-.002 18.956-11.779 35.978-29.328 42.364z" />
      </g>
    </svg>
  );
};
